// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WhiteHeader_wrapper_1r7dr","container":"WhiteHeader_container_3GMY9","logo":"WhiteHeader_logo__d0G6","icon":"WhiteHeader_icon_BjM_W","right":"WhiteHeader_right_oJcSI"};